var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4V0H12V4H10ZM16.65 6.75L15.275 5.375L18.075 2.5L19.475 3.925L16.65 6.75ZM18 12V10H22V12H18ZM10 22V18H12V22H10ZM5.35 6.7L2.5 3.925L3.925 2.525L6.75 5.35L5.35 6.7ZM18.05 19.5L15.275 16.625L16.625 15.275L19.475 18.025L18.05 19.5ZM0 12V10H4V12H0ZM3.925 19.5L2.525 18.075L5.325 15.275L6.05 15.95L6.775 16.65L3.925 19.5ZM11 17C9.33333 17 7.91667 16.4167 6.75 15.25C5.58333 14.0833 5 12.6667 5 11C5 9.33333 5.58333 7.91667 6.75 6.75C7.91667 5.58333 9.33333 5 11 5C12.6667 5 14.0833 5.58333 15.25 6.75C16.4167 7.91667 17 9.33333 17 11C17 12.6667 16.4167 14.0833 15.25 15.25C14.0833 16.4167 12.6667 17 11 17ZM11 15C12.1 15 13.0417 14.6083 13.825 13.825C14.6083 13.0417 15 12.1 15 11C15 9.9 14.6083 8.95833 13.825 8.175C13.0417 7.39167 12.1 7 11 7C9.9 7 8.95833 7.39167 8.175 8.175C7.39167 8.95833 7 9.9 7 11C7 12.1 7.39167 13.0417 8.175 13.825C8.95833 14.6083 9.9 15 11 15Z",
    fill: "#E3E3E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightMode);
export default __webpack_public_path__ + "static/media/light-mode.dc5394da1af858f17e134d69030753dd.svg";
export { ForwardRef as ReactComponent };